// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BgColorsOutlinedSvg from "@ant-design/icons-svg/es/asn/BgColorsOutlined";
import AntdIcon from '../components/AntdIcon';

var BgColorsOutlined = function BgColorsOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BgColorsOutlinedSvg
  }));
};

BgColorsOutlined.displayName = 'BgColorsOutlined';
export default React.forwardRef(BgColorsOutlined);